(() => {
  function initialize(root) {
    if (root.dataset.ready) return;
    const data = JSON.parse(root.querySelector('[data-comb-reviews-json]').textContent);
    const reviews = data.reviews || [];
    if (!reviews.length) return;
    root.dataset.ready = 'true';
    const get = s => root.querySelector(s);
    const make = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; };
    const average = reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length;
    function stars(rating) {
      const holder = make('span', 'rc-review-stars');
      holder.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 5; i++) {
        const slot = make('span', 'rc-star-slot');
        const svg = '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14l-5-4.87 6.91-1.01Z"/></svg>';
        const empty = make('span', 'rc-star-track'), fill = make('span', 'rc-star-fill');
        empty.innerHTML = svg; fill.innerHTML = svg;
        fill.style.width = `${Math.max(0, Math.min(1, rating - i)) * 100}%`;
        slot.append(empty, fill); holder.append(slot);
      }
      return holder;
    }
    const total = get('[data-review-total]');
    const score = make('div', 'rc-review-score');
    score.append(make('strong', '', average.toFixed(2)), make('span', '', '/5.0'));
    total.append(score, stars(average), make('p', '', `${reviews.length} customer reviews`));
    for (let rating = 5; rating >= 1; rating--) {
      const n = reviews.filter(r => r.rating === rating).length;
      const row = make('div', 'rc-rating-row');
      const track = make('span', 'rc-rating-track'), fill = make('span');
      fill.style.width = `${n / reviews.length * 100}%`; track.append(fill);
      row.append(make('span', '', `${rating} stars`), track, make('span', '', String(n)));
      get('[data-review-distribution]').append(row);
    }
    document.querySelectorAll('[data-comb-review-summary]').forEach(link => {
      link.replaceChildren(stars(average), make('span', 'rc-review-average', `${average.toFixed(2)}/5.0`), make('span', '', `${reviews.length} reviews`));
      link.setAttribute('aria-label', `${average.toFixed(2)} out of 5, ${reviews.length} reviews. Read customer reviews.`);
      link.hidden = false;
    });
    let limit = 4;
    const ordered = [...reviews.filter(r => r.images.length), ...reviews.filter(r => !r.images.length)];
    function render() {
      const rating = get('[data-review-rating]').value;
      const photoOnly = get('[data-review-photos]').checked;
      const filtered = ordered.filter(r => (rating === 'all' || r.rating === Number(rating)) && (!photoOnly || r.images.length));
      const container = get('[data-review-cards]'); container.replaceChildren();
      filtered.slice(0, limit).forEach(r => {
        const card = make('article', 'rc-review-card'); card.dataset.reviewId = r.id;
        r.images.forEach(url => {
          const button = make('button', 'rc-review-image'); button.type = 'button'; button.setAttribute('aria-label', `Enlarge photo from ${r.author}`);
          const img = make('img'); img.src = url; img.alt = `Styling comb photo shared by ${r.author}`; img.width = 600; img.height = 600; img.loading = 'lazy'; button.append(img);
          button.addEventListener('click', () => { const full = get('[data-review-photo-full]'); full.src = url; full.alt = img.alt; get('[data-review-photo-dialog]').showModal(); });
          card.append(button);
        });
        const body = make('div', 'rc-review-card-body');
        body.append(stars(r.rating), make('span', 'rc-sr-only', `${r.rating} out of 5 stars`), make('h3', '', r.author), make('p', '', r.text)); card.append(body); container.append(card);
      });
      if (!filtered.length) container.append(make('p', '', 'No reviews match this filter.'));
      get('[data-review-showing]').textContent = `${Math.min(limit, filtered.length)} of ${filtered.length} reviews`;
      get('[data-review-more]').hidden = limit >= filtered.length;
    }
    get('[data-review-more]').addEventListener('click', () => { limit += 8; render(); });
    ['[data-review-rating]', '[data-review-photos]'].forEach(s => get(s).addEventListener('change', () => { limit = 4; render(); }));
    get('[data-review-write]').addEventListener('click', () => get('[data-review-write-dialog]').showModal());
    root.querySelectorAll('[data-review-close]').forEach(b => b.addEventListener('click', () => b.closest('dialog').close()));
    root.querySelectorAll('dialog').forEach(d => d.addEventListener('click', e => { if (e.target === d) { const b = d.getBoundingClientRect(); if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) d.close(); } }));
    if (get('[data-review-submitted]') || get('#rc-review-form .errors')) get('[data-review-write-dialog]').showModal();
    render();
  }
  document.querySelectorAll('[data-comb-reviews]').forEach(initialize);
  document.addEventListener('shopify:section:load', e => { e.target.querySelectorAll('[data-comb-reviews]').forEach(initialize); });
})();
